import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Attendee, BaseAssetFragment } from '../../../generated/graphql.generated';
import { EventAttendeeRoles } from '../../global.constants';
import { DetailsHelperService } from '../../services/details-helper.service';
import { ASSET_TYPES } from '../../shared/assets/assets';
import { CrewListComponent } from '../crew-list/crew-list.component';

@Component({
  selector: 'app-schedule-resource-label',
  templateUrl: './schedule-resource-label.component.html',
  styleUrls: ['./schedule-resource-label.component.scss'],
  standalone: true,
  imports: [CommonModule, CrewListComponent]
})
export class ScheduleResourceLabelComponent implements OnInit {

  @Input() title: string;
  @Input() asset: BaseAssetFragment;
  
  private _commonCrew: Attendee[] = [];
  @Input() set commonCrew(value: any[]) {
    this._commonCrew = value || [];
    this.sortCommonCrew();
  }
  get commonCrew(): any[] {
    return this._commonCrew;
  }

  @Input() showCrew = false;
  @Input() template: any; // Availability template
  
  @Output() remove = new EventEmitter<Event>();

  private _sortedCommonCrew: Attendee[] = [];

  constructor(
    private detailsHelper: DetailsHelperService
  ) { }

  ngOnInit(): void {
    this.sortCommonCrew();
  }

  getIcon(type: string): string {
    return ASSET_TYPES[type]?.icon || '';
  }

  private sortCommonCrew() {
    if (!this._commonCrew) {
      this._sortedCommonCrew = [];
      return;
    }
    this._sortedCommonCrew = [...this._commonCrew].sort((a, b) => {
      const aIsLead = a.role === EventAttendeeRoles.crewLead || a.role === EventAttendeeRoles.assistantCrewLead;
      const bIsLead = b.role === EventAttendeeRoles.crewLead || b.role === EventAttendeeRoles.assistantCrewLead;
      
      if (aIsLead && !bIsLead) return -1;
      if (!aIsLead && bIsLead) return 1;
      return 0;
    });
  }

  get sortedCommonCrew(): Attendee[] {
    return this._sortedCommonCrew;
  }

  openDetails() {
    if (this.asset) {
      this.detailsHelper.open('asset', { id: this.asset.id });
    } else if (this.template) {
      this.detailsHelper.open('availability-template', this.template);
    }
  }

  onRemove(event: Event) {
    event.stopPropagation();
    this.remove.emit(event);
  }

}
